export function datePosition(date: Date, start: Date, end: Date) {
  const n = date.getTime() - start.getTime();
  const t = end.getTime() - start.getTime();
  const p = n / t;

  return p;
}
